module.exports = __webpack_public_path__ + "img/convergists7.388f438f.png";